import api from './api.service';

export interface CustomerCreditNote {
  id: string;
  company_id: string;
  customer_id: string;
  credit_note_number: string;
  credit_note_date: string;
  total_amount: number;
  status: string;
  reason?: string | null;
  original_sales_invoice_id?: string | null;
  journal_voucher_id?: string | null;
  created_at?: string;
  updated_at?: string;
  customer?: { id: string; customer_name?: string };
  originalSalesInvoice?: { id: string; invoice_number?: string };
}

export interface CreateCustomerCreditNoteDTO {
  customer_id: string;
  credit_note_date: string;
  total_amount: number;
  reason?: string;
  original_sales_invoice_id?: string;
}

export interface UpdateCustomerCreditNoteDTO {
  customer_id?: string;
  credit_note_date?: string;
  total_amount?: number;
  reason?: string;
  original_sales_invoice_id?: string | null;
}

class CustomerCreditNoteService {
  async list(filters?: {
    customer_id?: string;
    status?: string;
    from_date?: string;
    to_date?: string;
  }): Promise<CustomerCreditNote[]> {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value != null && value !== '') params.append(key, String(value));
      });
    }
    const response = await api.get<CustomerCreditNote[]>(`/finance/credit-notes?${params.toString()}`);
    const raw = (response as any)?.data ?? response;
    return Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : [];
  }

  async getById(id: string): Promise<CustomerCreditNote> {
    const response = await api.get<CustomerCreditNote>(`/finance/credit-notes/${id}`);
    const raw = (response as any)?.data ?? response;
    return raw?.data ?? raw;
  }

  async create(dto: CreateCustomerCreditNoteDTO): Promise<CustomerCreditNote> {
    const response = await api.post<CustomerCreditNote>('/finance/credit-notes', dto);
    const raw = (response as any)?.data ?? response;
    return raw?.data ?? raw;
  }

  async post(id: string): Promise<CustomerCreditNote> {
    const response = await api.post<CustomerCreditNote>(`/finance/credit-notes/${id}/post`);
    const raw = (response as any)?.data ?? response;
    return raw?.data ?? raw;
  }

  async update(id: string, dto: UpdateCustomerCreditNoteDTO): Promise<CustomerCreditNote> {
    const response = await api.put<CustomerCreditNote>(`/finance/credit-notes/${id}`, dto);
    const raw = (response as any)?.data ?? response;
    return raw?.data ?? raw;
  }

  async cancel(id: string): Promise<CustomerCreditNote> {
    const response = await api.post<CustomerCreditNote>(`/finance/credit-notes/${id}/cancel`);
    const raw = (response as any)?.data ?? response;
    return raw?.data ?? raw;
  }
}

const customerCreditNoteService = new CustomerCreditNoteService();
export default customerCreditNoteService;
